<template>
    <div class="flex justify-center">
        <el-tooltip
            :open-delay="200"
            effect="dark"
            :disabled="!assignedAndUnavailableAgents.length"
            placement="top">

            <div slot="content">
                <p
                    v-for="(agent, index) in assignedAndUnavailableAgents"
                    :key="agent.user.UserID"
                    :class="{
                        'mb-1': index !== assignedAndUnavailableAgents.length - 1
                    }"
                >
                    {{ agent.userName }}
                </p>
            </div>

            <div>
                {{ String(assignedAndUnavailableAgents.length) }}
            </div>

        </el-tooltip>
    </div>
</template>

<script>
import { Tooltip } from 'element-ui'
import queueColumnMixin from '@/mixins/queueAgentsColumnMixin'

export default {
    mixins: [ queueColumnMixin ],
    components: {
        [Tooltip.name]: Tooltip,
    },
    computed: {
        /**
         * All the agents which are assigned to the queue and are unavailable
         *
         * The agent is unavailable if:
         * - The agent is not available by calls
         * - The agent is not available by status
         *
         * @returns {UserData[]}
         */
        assignedAndUnavailableAgents() {
            // TODO RTD-695 wait for queueRule to be in extension event call object
            return Object.values(this.queueMembersMap).filter((member) => {
                return !this.isQueueMemberAvailableByCalls(member) || !this.isQueueMemberAvailableByStatus(member)
            })
        },
    }
}
</script>
